import { purry } from './purry';
export function pick() {
  return purry(_pick, arguments);
}

function _pick(object, names) {
  if (object == null) {
    return {};
  }

  return names.reduce(function (acc, name) {
    acc[name] = object[name];
    return acc;
  }, {});
}